if (!customElements.get('cart-upsell')) {
class CartUpsell extends HTMLElement {
  // Renseigner ce token pour activer la vérification de dispo par marché via la Storefront API.
  // Laisser vide pour désactiver la vérification (les cards seront toutes affichées).
  static STOREFRONT_ACCESS_TOKEN = '';

  connectedCallback() {
    const cards = this.querySelectorAll('[data-product-id]');
    if (!cards.length) return;

    cards.forEach((card) => this.initVariantSelects(card));

    // Empêcher les clics multiples : quand un bouton upsell est cliqué,
    // désactiver immédiatement tous les AUTRES boutons jusqu'au re-render du drawer
    this.querySelectorAll('.cart_upsell_addtocart').forEach((btn) => {
      btn.addEventListener('click', () => {
        this.querySelectorAll('.cart_upsell_addtocart').forEach((other) => {
          if (other !== btn) {
            other.setAttribute('aria-disabled', 'true');
            other.style.pointerEvents = 'none';
          }
        });
      });
    });

    if (!CartUpsell.STOREFRONT_ACCESS_TOKEN) return;

    const country = this.dataset.country;
    const shop = this.dataset.shop;
    if (!country || !shop) return;

    const productIds = [...cards].map((card) => card.dataset.productId);
    this.checkAvailability(shop, country, productIds);
  }

  // ---------- Variantes ----------

  initVariantSelects(card) {
    const selects = card.querySelectorAll('.cart_upsell__select');
    if (!selects.length) return;

    const variants = JSON.parse(card.dataset.variants || '[]');

    selects.forEach((select) => this.filterUnavailableOptions(select, selects, variants));

    selects.forEach((select) => {
      select.addEventListener('change', () => {
        selects.forEach((s) => this.filterUnavailableOptions(s, selects, variants));
        this.updateVariant(card, selects, variants);
      });
    });

    this.updateVariant(card, selects, variants);
  }

  filterUnavailableOptions(targetSelect, allSelects, variants) {
    const optionIndex = parseInt(targetSelect.dataset.optionIndex, 10);

    const selectedOptions = [...allSelects].map((s) =>
      s === targetSelect ? null : s.value
    );

    [...targetSelect.options].forEach((option) => {
      const testOptions = [...selectedOptions];
      testOptions[optionIndex] = option.value;

      const hasAvailable = variants.some((v) => {
        return v.available && testOptions.every((val, i) => val === null || v.options[i] === val);
      });

      option.disabled = !hasAvailable;
      option.hidden = !hasAvailable;
    });

    if (targetSelect.selectedOptions[0]?.disabled) {
      const firstEnabled = [...targetSelect.options].find((o) => !o.disabled);
      if (firstEnabled) targetSelect.value = firstEnabled.value;
    }
  }

  updateVariant(card, selects, variants) {
    const selectedOptions = [...selects].map((s) => s.value);

    const matchingVariant = variants.find(
      (v) => v.available && v.options.every((opt, i) => opt === selectedOptions[i])
    );

    const input = card.querySelector('input[name="id"]');
    const button = card.querySelector('.cart_upsell_addtocart');

    if (matchingVariant) {
      input.value = matchingVariant.id;
      button.disabled = false;
    } else {
      button.disabled = true;
    }
  }

  // ---------- Dispo par marché (Storefront API) ----------

  async checkAvailability(shop, country, productIds) {
    const query = `
      query checkAvailability($ids: [ID!]!) @inContext(country: ${country}) {
        nodes(ids: $ids) {
          ... on Product {
            id
            availableForSale
          }
        }
      }
    `;

    const variables = {
      ids: productIds.map((id) => `gid://shopify/Product/${id}`),
    };

    try {
      const response = await fetch(`https://${shop}/api/2026-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': CartUpsell.STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({ query, variables }),
      });

      const { data } = await response.json();
      if (!data?.nodes) return;

      data.nodes.forEach((node) => {
        if (!node || node.availableForSale) return;

        const numericId = node.id.split('/').pop();
        const card = this.querySelector(`[data-product-id="${numericId}"]`);
        if (card) card.remove();
      });
    } catch (e) {
      console.error('[CartUpsell] Storefront API error:', e);
    }
  }
}

customElements.define('cart-upsell', CartUpsell);
}
